import React, { useState } from 'react';
import { ChevronDown, } from 'lucide-react';
import '../../css/header-menu/faq.css';
import Header from '../Home/header';
import Footer from '../Home/footer';

const FAQItem = ({ question, answer, isOpen, onToggle }) => {
    return (
        <div className="faqItem">
            <button className="question" onClick={onToggle}>
                <span>{question}</span>
                <ChevronDown
                    className={`icon4 ${isOpen ? 'iconRotate' : ''}`}
                />
            </button>
            {isOpen && (
                <div className="answer">
                    {answer}
                </div>
            )}
        </div>
    );
};

const EVChargingFAQ = () => {
    const [openItems, setOpenItems] = useState(new Set());

    const faqData = [
        {
            question: "Evime şarj istasyonu kurabilir miyim?",
            answer: "Evet, evinize şarj istasyonu kurabilirsiniz. Ev tipi şarj istasyonları genellikle 3.7 kW ile 22 kW arasında güç sağlar ve AC tipindedir. Evde şarj istasyonu kullanmanın avantajları: gece boyunca rahat şarj imkanı, düşük tarife ile ekonomik şarj ve kişisel kullanım kolaylığıdır. Kurulum öncesi evinizin elektrik altyapısının uygunluğunu kontrol ettirmeniz önemlidir."
        },
        {
            question: "Siteme şarj istasyonu kurulumu nasıl yaparım?",
            answer: "Yeni düzenlemelerle Sitenize şarj istasyonu kurulumu kolaylaştırıldı. Ortak alanlara kurulum için kat maliklerinin çoğunluk kararı yeterlidir. Bağımsız bölümlerde ise çoğunluk kararına gerek yoktur. Ancak her durumda elektrik kurumundan gerekli onayların alınması zorunludur. Bu düzenleme ticari amaçlı kullanımları kapsamamaktadır."
        },
        {
            question: "Kurulum süreci hangi aşamalardan oluşur?",
            answer: (
                <div className="faq-content">
                    <p className="faq-intro">Kurulum süreci şu aşamalardan oluşur:</p>
                    <ol className="steps-list">
                        <li>İhtiyaç analizi ve planlama - lokasyon ve kapasite belirleme</li>
                        <li>Gerekli izinlerin alınması - belediye ve elektrik dağıtım şirketi onayları</li>
                        <li>Elektrik altyapısının hazırlanması</li>
                        <li>Şarj ünitesi montajı ve kablolama</li>
                    </ol>
                    <div className="pdf-downloads">
                        <p className="pdf-desc">Detaylı bilgi için aşağıdaki dokümanları inceleyebilirsiniz:</p>
                        <div className="pdf-buttons">
                            <a
                                href="/assets/docs/DAPSC-AC-B1-CP%20Kullanım%20Klavuzu.pdf"
                                className="pdf-button"
                                download
                            >
                                DAPSC-AC-B1-CP Kullanım Klavuzu
                                <img src="/assets/docs/image.png" alt="PDF" width="20" />
                            </a>
                            <a
                                href="/assets/docs/DAPSC-AC-B3-CP%20Kullanım%20Klavuzu.pdf"
                                className="pdf-button"
                                download
                            >
                                DAPSC-AC-B3-CP Kullanım Klavuzu
                                <img src="/assets/docs/image.png" alt="PDF" width="20" />
                            </a>
                        </div>
                    </div>
                </div>
            )
        },
        {
            question: "Şarj istasyonu kurulumu için hangi izinler gereklidir?",
            answer: "Kurulum için gerekli temel izinler: belediye ve yerel yönetim izinleri, elektrik dağıtım şirketi onayı ve bazı durumlarda EPDK lisansıdır. Ayrıca, apartman ve site gibi ortak kullanım alanlarında kat malikleri kurulundan da onay almanız gerekebilir."
        },
        {
            question: "Gece tarifesinden yararlanabilir miyim?",
            answer: "Evet, ev tipi şarj istasyonumuz akıllı şarj özelliği sayesinde gece tarifesinden yararlanmanızı sağlar. Gece 22:00 - sabah 06:00 arasındaki düşük tarifeli saatlerde şarj ederek maliyetlerinizi önemli ölçüde düşürebilirsiniz."
        },
        {
            question: "Garanti kapsamı neleri içerir?",
            answer: "Ev tipi şarj istasyonlarımız 2 yıl garantilidir. Bu süre içinde üretim hatası veya normal kullanımdan kaynaklanan tüm arızalar ücretsiz onarılır. Garanti, cihazın kendisi, montaj ve işçilik dahil tüm bileşenleri kapsar."
        },
        {
            question: "Şarj istasyonumu farklı marka araçlar kullanabilir mi?",
            answer: "Evet, şarj istasyonlarımız Avrupa standardı Type 2 soket tipine sahiptir. Togg, Tesla, BMW, Mercedes, Volkswagen, Renault, Hyundai gibi tüm yaygın elektrikli araç markalarıyla uyumlu şekilde çalışır."
        },
        {
            question: "Mobil uygulama ne işe yarar?",
            answer: (
                <ul className="faq-list">
                    <li>Şarj durumunuzu uzaktan takip edebilir</li>
                    <li>Şarj programı oluşturabilir</li>
                    <li>Enerji tüketiminizi ve maliyetlerinizi görüntüleyebilir</li>
                    <li>Şarj geçmişinizi inceleyebilir</li>
                    <li>Teknik destek alabilirsiniz</li>
                </ul>
            )
        },
        {
            question: "Şarj istasyonum arıza yaparsa ne yapmalıyım?",
            answer: "7/24 ulaşabileceğiniz teknik destek hattımız bulunmaktadır. Çoğu sorunu uzaktan çözebiliyoruz. Yerinde müdahale gerektiğinde ise 24 saat içinde teknik ekibimiz sorunu çözmek için evinizi ziyaret eder."
        },
        {
            question: "Verilerim Benim rızam dışında kullanılabilir mi?",
            answer: "Hayır, verileriniz sadece sizin kullanımınız için kullanılır. Verilerinizin kullanımınız dışında kullanılması gibi bir durum söz konusu değildir."
        },
        {
            question: "Verilerim ben uygulamayı kaldırdıktan sonra ne yapılır?",
            answer: "Uygulama kaldırıldıktan sonra verilerinizin silinmesi gerekir. Bu işlem için lütfen bizimle iletişime geçiniz."
        },
    ];

    const toggleItem = (index) => {
        const newOpenItems = new Set(openItems);
        if (newOpenItems.has(index)) {
            newOpenItems.delete(index);
        } else {
            newOpenItems.add(index);
        }
        setOpenItems(newOpenItems);
    };

    return (
        <div>
            <Header />
            <div className="faqContainer">
                <h1 className="title">
                    Elektrikli Araç Şarj İstasyonu Kurulumu - Sıkça Sorulan Sorular
                </h1>
                <div className="faqList">
                    {faqData.map((item, index) => (
                        <FAQItem
                            key={index}
                            question={item.question}
                            answer={item.answer}
                            isOpen={openItems.has(index)}
                            onToggle={() => toggleItem(index)}
                        />
                    ))}
                </div>

            </div>
            <Footer />
        </div>
    );
};


export default EVChargingFAQ;